import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorOpen, faChevronRight, faRotate, faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useUnidades } from "../../../hooks/test/useUnidades";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import ModalComponent from "../../customComponents/Modals/ModalComponent";

export const TarjetaAperturaUnidad = ({ unidad_id, comandos }) => {
  const { executeAperturaCerradura, getAperturaCerradura, getUnidad, postBitacora, putConfirmacionApertura } = useUnidades();
  const [fase, setFase] = useState(0); // 0=inactivo, 1=azul, 2=amarillo, 3=verde, 4=error
  const [parpadeando, setParpadeando] = useState(null);
  const [errorPaso, setErrorPaso] = useState(null); // 👈 nuevo estado para saber en qué paso falló
  const [comando_Id, setComandoId] = useState(null);
  const [isHistorialOpen, setIsHistorialOpen] = useState(false);
  const [comandosUnidad, setComandosUnidad] = useState(comandos || []);
  const [shouldShow, setShouldShow] = useState(false);
  const [colorIcono, setColorIcono] = useState("#2e333b");
  const [selectedOption, setSelectedOption] = useState(null); // "ok", "no"
  const [comandLogId, setComandLogId] = useState(null);
  const [reintentoConsulta, setReintentoConsulta] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [contadorReconsultas, setContadorReconsultas] = useState(0);

  const handleClick = async () => {
    // if (fase !== 0) return;
    if (isProcessing) {
      toast.info("Ya hay una apertura en proceso, espera un momento...");
      return;
    }

    setIsProcessing(true); // 🔥 bloquear

    setSelectedOption(null);

    const result = await Swal.fire({
      title: "¿Estás seguro de ejecutar la apertura de esta unidad?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, ejecutar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    });

    if (!result.isConfirmed) {
      setIsProcessing(false);
      return;
    }

    try {
      // 🟦 Fase 1
      setFase(1);
      setParpadeando(1);
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Ejecutar apertura
      const executeApertura = await executeAperturaCerradura(unidad_id);

      // 🟨 Fase 2
      setFase(2);
      setParpadeando(2);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setParpadeando(null);

      if (executeApertura.ok) {
        setParpadeando(3);
        toast.success(executeApertura.msg || "Apertura ejecutada exitosamente");
        setComandoId(executeApertura.data.comandoId);
        await new Promise((resolve) => setTimeout(resolve, 10000));
        await consultaApertura(executeApertura.data.comandoId);
      } else {
        // ❌ Falla el primer servicio
        toast.error(executeApertura.msg || "Error en la apertura");
        setErrorPaso(2); // 👈 marca que falló en el segundo paso
        setFase(4); // error
      }
    } catch (error) {
      console.error(error);
      toast.error("Error inesperado al ejecutar la apertura");
      setErrorPaso(2); // por defecto, error temprano
      setFase(4);
    } finally {
      setIsProcessing(false); // 🔥 desbloquear SIEMPRE
    }
  };

  const consultaApertura = async (comandoId) => {
    setParpadeando(3);
    const resp = await getAperturaCerradura(comandoId, unidad_id);

    if (resp.ok) {
      if (resp.plataforma.aperturaCerradura) {

        let respAct = await getUnidad(unidad_id);
        if (respAct.ok) {
          // ✅ Actualiza el estado local
          setComandosUnidad(respAct.unidad.comands_logs);
        }
        if (respAct.unidad.viajes.length != 0)
          await postBitacora({
            id_viaje: respAct.unidad.viajes[0].viaje_id,
            notas: "Apertura de chapas desde la Bitacora",
            id_status: 38,
          });
        toast.success("Confirmación de apertura enviada");
        setFase(3);
        setParpadeando(3);
        setShouldShow(true);
      } else {

        let respAct = await getUnidad(unidad_id);
        if (respAct.ok) {
          // ✅ Actualiza el estado local
          setComandosUnidad(respAct.unidad.comands_logs);
        }

        // ❌ No responde el equipo a el comando enviado
        toast.info(resp.info || "Sin respuesta de apertura enviada");
        setErrorPaso(3); // 👈 marca que falló en el tercer paso
        setFase(4); // error
      }

      await new Promise((resolve) => setTimeout(resolve, 3000));
      setParpadeando(null);
    } else {
      // ❌ Falla el segundo servicio
      toast.error("Sin respuesta al comando de apertura");
      setErrorPaso(3); // 👈 marca que falló en el tercer paso
      setFase(4); // error
      setParpadeando(null);
    }
    setReintentoConsulta(false);
  }

  useEffect(() => {
    const ultimoComando = comandosUnidad?.[comandosUnidad.length - 1];
    setComandLogId(ultimoComando?.comand_log_id);
    const color = ultimoComando
      ? ultimoComando.apertura
        ? 'green'
        : '#dc3545'
      : '#2e333b';
    setColorIcono(color);

    const today = new Date();
    const created = ultimoComando ? new Date(ultimoComando.createdAt) : null;

    // Comparar solo año-mes-día
    const sameDate =
      created &&
      created.getFullYear() === today.getFullYear() &&
      created.getMonth() === today.getMonth() &&
      created.getDate() === today.getDate();

    // Mostrar solo si apertura === true Y la fecha coincide
    const valido = ultimoComando?.apertura === true && sameDate;
    if (ultimoComando?.confirmacion_comando === null && valido) {
      // console.log("ultimoComando?.confirmacion_comando" + ultimoComando?.confirmacion_comando);
      setShouldShow(true);
    } else {
      setShouldShow(false);
    }

    // 🚨🚨 *** NUEVO: DETECTAR SI EL COMANDO SIGUE “PENDIENTE” Y RECONSULTAR ***
    if (!ultimoComando || !created) return;

    const diferenciaMs = today - created;       // Diferencia en milisegundos
    const treintaMinMs = 15 * 60 * 1000;      // 30 minutos
    const dentroDe30Min = diferenciaMs <= treintaMinMs;

    const esPendiente =
      sameDate &&
      dentroDe30Min &&
      ultimoComando.confirmacion_comando === null &&
      ultimoComando.apertura === false; // apertura aún NO confirmada

    if (esPendiente && !isProcessing) {
      setIsProcessing(true);            // 🔥 bloquear
      setReintentoConsulta(true);
      console.log("🔄 Reintentando consulta del comando pendiente ID:", ultimoComando.comando_id);

      // Guardar ID del comando en estado para reintentos manuales
      setComandoId(ultimoComando.comand_log_id);

      // Ejecutar consulta automáticamente si el usuario regresa a la pantalla
      consultaApertura(ultimoComando.comando_id).finally(() => setIsProcessing(false)); // 🔥 desbloquear al terminar
    }

  }, [comandosUnidad]);

  useEffect(() => {
    const ultimoComando = comandosUnidad?.[comandosUnidad.length - 1];
    if (!ultimoComando) return;

    const estaPendiente =
      ultimoComando.confirmacion_comando === null &&
      ultimoComando.apertura === false;

    if (!estaPendiente) return;

    const created = new Date(ultimoComando.createdAt);
    const now = new Date();
    const diffMs = now - created;
    const quinceMin_ms = 15 * 60 * 1000;

    if (diffMs > quinceMin_ms) {
      console.log("⛔ Más de 15 minutos → no reconsultar");
      return;
    }

    if (contadorReconsultas >= 3) {
      console.log("⛔ Máximo de 3 reconsultas alcanzado");
      return;
    }

    console.log(`⏳ Reconsulta #${contadorReconsultas + 1} programada en 20s...`);

    const timer = setTimeout(() => {
      if (!isProcessing) {
        setIsProcessing(true);

        consultaApertura(ultimoComando.comando_id)
          .finally(() => {
            setIsProcessing(false);
            setContadorReconsultas((n) => n + 1);
          });
      }
    }, 20000);

    return () => clearTimeout(timer);
  }, [comandosUnidad, contadorReconsultas]);


  const handleUserConfirm = async (valor) => {

    setSelectedOption(valor ? "ok" : "no");
    let confirm;
    // console.log("vlor:" + valor);
    if (valor) {
      confirm = true;
    } else {
      confirm = false;
    }

    let resp = await putConfirmacionApertura(comandLogId, { "confirmacion": confirm });
    if (resp.ok && valor) {
      toast.success("Apertura registrada y confirmada por el usuario");
    } else if (resp.ok && !valor) {
      toast.success("Apertura registrada, el usuario indicó que NO se aperturó");
    } else {
      toast.success(resp.sms || "Error al guardar la confirmación de apertura");
    }

    setTimeout(() => {
      setShouldShow(false);   // 👈 IMPORTANTE: esto es lo que hace que sea col-12
    }, 2000); // oculta después de 2s

  };

  return (
    <>
      <div className="row">
        <div id="conteinerApertura" className="col-6">
          <div className="row">
            <div
              className={`col-anim ${shouldShow ? "col-6" : "col-12"
                } ${fase === 0 ? "noEjecutada" : ""}`}
              style={{
                display: shouldShow ? "none" : "block",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleClick}
            >
              <h6>
                <FontAwesomeIcon
                  icon={faDoorOpen}
                  style={{ color: colorIcono, fontSize: '25px' }}
                  className={`${reintentoConsulta && "parpadeando"}`}
                  title="Aperturar chapa"
                />
              </h6>
            </div>

            {shouldShow && (
              <div
                className={`${shouldShow ? "col-12" : "col-6"}`}
                style={{
                  display: shouldShow ? "flex" : "none",
                  gap: "20px",
                  marginTop: shouldShow ? "35px" : "10px",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                {/* ✔️ ICONO OK */}
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  className={`confirmIcon ${selectedOption === "ok" ? "icon-ok" : ""}`}
                  onClick={() => handleUserConfirm(true)}
                  title="Confirmación de apertura"
                />

                {/* ❌ ICONO NO */}
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  className={`confirmIcon ${selectedOption === "no" ? "icon-no" : ""}`}
                  onClick={() => handleUserConfirm(false)}
                  title="Denegación de apertura"
                />
              </div>
            )}

          </div>
          {fase !== 0 && (
            <div className="puntos cursor">
              {/* 🔵 Punto 1 */}
              <span
                className={`punto 
                ${fase >= 1 ? "azul" : ""} 
                ${parpadeando === 1 ? "parpadeando" : ""}`}
              ></span>

              {/* 🟨 Punto 2 o 🔴 si error en paso 2 */}
              <span
                className={`punto 
                ${fase >= 2 && fase !== 4
                    ? "amarillo" // fase 2 o más, sin error → amarillo
                    : fase === 4 && errorPaso === 3
                      ? "amarillo" // error en paso 3 → mantener amarillo
                      : fase === 4 && errorPaso === 2
                        ? "rojo" // error en paso 2
                        : ""
                  }
                ${parpadeando === 2 ? "parpadeando" : ""}`
                }
              ></span>

              {/* 🟩 Punto 3 o 🔴 si error en paso 3 (convertido en faRotate) */}
              {fase === 4 && errorPaso === 3 ? (
                <FontAwesomeIcon
                  icon={faRotate}
                  style={{
                    color: "red",
                    fontSize: "12px", // 👈 ajusta al tamaño de tus puntos
                    margin: "0 4px",
                    transition: "transform 0.3s ease",
                  }}
                  className={`${parpadeando === 3 ? "parpadeando" : ""}`}
                  // onClick={() => consultaApertura(comando_Id)}
                  onClick={() => {
                    if (isProcessing) {
                      toast.info("Ya hay una consulta en proceso...");
                      return;
                    }

                    setIsProcessing(true);
                    consultaApertura(comando_Id)
                      .finally(() => setIsProcessing(false));
                  }}
                />
              ) : (
                <span
                  className={`punto 
                  ${fase >= 3 && fase !== 4 ? "verde" : ""} 
                  ${parpadeando === 3 ? "parpadeando" : ""}`}
                ></span>
              )}
            </div>
          )}
        </div>
        <div className="plus col-6">
          <h6>
            <FontAwesomeIcon
              icon={faChevronRight}
              onClick={() => setIsHistorialOpen(true)} // 👈 abre el modal personalizado
              style={{ cursor: "pointer" }}
            />
          </h6>
        </div>
      </div>
      <ModalComponent
        isOpen={isHistorialOpen}
        onClose={() => setIsHistorialOpen(false)}
        onConfirm={() => setIsHistorialOpen(false)}
        title="Histórico de Aperturas"
        className="historialWrapper"        // 👈 tu clase personalizada
        overlayClassName="historialOverlay" // 👈 overlay transparente
        hideFooter={true} // 👈 oculta el footer solo aquí
      >
        {comandosUnidad && comandosUnidad.length > 0 ? (
          <ul className="list-group list-group-flush">
            {comandosUnidad?.slice().reverse().map((cmd) => (
              <li
                key={cmd.comand_log_id}
                className="list-group-item d-flex justify-content-between align-items-center"
              >
                <div>
                  <strong>{new Date(cmd.createdAt).toLocaleString()}</strong>
                  <br />
                  <small>
                    Usuario: {cmd.user.name} | Unidad: {cmd.unidad.unidad_numero}
                    <br />
                  </small>
                </div>
                <div>
                  {cmd.apertura ? (
                    <span className="text-success">
                      <FontAwesomeIcon icon={faCheckCircle} /> Éxito
                    </span>
                  ) : (
                    <span className="text-danger">
                      <FontAwesomeIcon icon={faTimesCircle} /> Fallo
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-muted">No hay registros en el historial.</p>
        )}
      </ModalComponent>
    </>
  );
};
